import styled, { css } from 'styled-components';
import { Colors } from '../../../constants/Colors';

const iconSize = size => (size == 'sm' ? '25px' : size == 'md' ? '25px' : '32px');

export const StyledIcon = styled.div``;

export const StyledIconImage = styled.img`
  color: white;
  height: ${props => iconSize(props.size)};
  width: ${props => iconSize(props.size)};
`;
